// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateRevisionModal_overlay__6cegg {
  text-align: left;  
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}

.CreateRevisionModal_modal__-BEt1 {
  background: #fff;
  border-radius: 12px;
  width: 400px;
  padding: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: CreateRevisionModal_fadeIn__QEpiP 0.25s ease;
}

.CreateRevisionModal_header__NKh0Q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.CreateRevisionModal_header__NKh0Q h2 {
  font-size: 18px;
  margin: 0;
}

.CreateRevisionModal_close__wLhF- {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.CreateRevisionModal_body__bIfpM {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.CreateRevisionModal_body__bIfpM label {
  font-weight: 500;
  margin-bottom: 6px;
}

.CreateRevisionModal_body__bIfpM input {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.CreateRevisionModal_errorInput__a3vaH {
  border-color: #e74c3c;
}

.CreateRevisionModal_errorText__uUxPd {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 4px;
}

.CreateRevisionModal_footer__Av5DH {
  margin-top: 20px;
  text-align: right;
}

.CreateRevisionModal_continue__dbWs2 {
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
}

.CreateRevisionModal_continue__dbWs2:hover {
  background: rgb(26, 126, 76);
}

@keyframes CreateRevisionModal_fadeIn__QEpiP {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CreateRevisionModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,uDAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".overlay {\n  text-align: left;  \n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1200;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 400px;\n  padding: 20px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.25s ease;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.header h2 {\n  font-size: 18px;\n  margin: 0;\n}\n\n.close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.body {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.body label {\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.body input {\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n}\n\n.errorInput {\n  border-color: #e74c3c;\n}\n\n.errorText {\n  color: #e74c3c;\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.footer {\n  margin-top: 20px;\n  text-align: right;\n}\n\n.continue {\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.continue:hover {\n  background: rgb(26, 126, 76);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CreateRevisionModal_overlay__6cegg`,
	"modal": `CreateRevisionModal_modal__-BEt1`,
	"fadeIn": `CreateRevisionModal_fadeIn__QEpiP`,
	"header": `CreateRevisionModal_header__NKh0Q`,
	"close": `CreateRevisionModal_close__wLhF-`,
	"body": `CreateRevisionModal_body__bIfpM`,
	"errorInput": `CreateRevisionModal_errorInput__a3vaH`,
	"errorText": `CreateRevisionModal_errorText__uUxPd`,
	"footer": `CreateRevisionModal_footer__Av5DH`,
	"continue": `CreateRevisionModal_continue__dbWs2`
};
export default ___CSS_LOADER_EXPORT___;
